import BrandingDesktopFormat from './BrandingDesktopFormat';
import ImageWithLinkFormat from "./ImageWithLinkFormat";

export default class FormatResolver {
    constructor() {
        this.formats = {};
        this.formats['BrandingDesktopFormat'] = BrandingDesktopFormat;
        this.formats['ImageWithLinkFormat'] = ImageWithLinkFormat;
    }

    resolve(type) {
        if (this.formats[type] === undefined) {
            throw new Error(`Error format type "${type}"`);
        }

        return this.formats[type];
    }
}
